import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";

export class GameAssets {

    public static BITMAP_FONT_WIN_COUNT_UP_LOW: string = "NumbersWinCountUp";

    public static IN_GAME_ARROW: string = "resources/images/in_game_arrow.png";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset("NumbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("NumbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt")
                ]
            },
            {
                name: "bonusSymbol",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("bonusSymbol0", "sheets/bonusSymbol/bonusSymbol0.json"),
                    new TextureAsset("bonusSymbol1", "sheets/bonusSymbol/bonusSymbol1.json"),
                    new TextureAsset("bonusSymbol2", "sheets/bonusSymbol/bonusSymbol2.json"),
                    new TextureAsset("bonusSymbol3", "sheets/bonusSymbol/bonusSymbol3.json"),
                    new TextureAsset("bonusSymbol4", "sheets/bonusSymbol/bonusSymbol4.json")
                ]
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json")
                ],
                animations: {
                    "reelDivider": "ui/reelDividers/div",
                    "reelDividerNearWin": "ui/reelDividers/div-attention",
                    "button": "ui/gameTweakerButton/button",
                    "button-disabled": "ui/gameTweakerButton/button-disabled",
                    "IdleReelBg": "SymWinFX/SymWinFX_",
                    "winReelBg": "SymWinFX_Initial/SymWinFX_Initial_",
                    "Wild_Expand4": "W_4to7/W_4to7_",
                    "Wild_Expand7": "W_7to10/W_7to10_",
                    "M_Reveal4": "FX_Burn/M4/M4_Burn_",
                    "M_Reveal5": "FX_Burn/M5/M5_Burn_",
                    "M_Reveal6": "FX_Burn/M6/M6_Burn_",
                    "M_Reveal7": "FX_Burn/M7/M7_Burn_",
                    "wTransform": "W_Transform/W_Transform_",
                    "wTransform1": "W_Transform/1/W_Transform_",
                    "ReelLocker": "Reel_Lock_Intro/Reel_Lock_Intro_",


                    "Poo": "Dead/Dead_Poo",
                    "Finger": "Dead/Dead_Finger",
                    "Blixt": "Dead/Dead_Blixt",
                    "Spray": "Dead/Dead_Spray"
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json"),
                    new TextureAsset("mainJpeg11", "sheets/mainJpeg/mainJpeg11.json")
                   

                ],
                animations: {
                    "mainBackground": "mainBackground",
                    "SymLandingFX": "SymLandingFX/SymLandingFX_",
                    "FX_HotZone_Win": "FX_HotZone_Win/FX_HZ_Win_",
                    "Wild_Win4": "W_Win_4/W_win_4_",
                    "Wild_Win7": "W_Win_7/W_win_7_",
                    "Wild_Win10": "W_Win_10/W_win_10_",
                    "S_to_W": "S_to_W/S_to_W_",
                    "S_AttentionWithSkull": "S_Attention_With_Skull/S_Attention_",
                    "S_AttentionWithoutSkull": "S_Attention_no_Skull/S_Attention_",
                    "S_Attention_1": "S_Attention_1/S_Attention_1_",
                    "S_to_Riot": "S_attention_RiotSpin/S_Attention_RiotSpin_",

                    "Reel6Attention_A": "FX_ReelAttention_A/Loop_A_",
                    "Reel6Attention_B": "FX_Reel6Attention_B/Loop_B_",

                    "FX_Reel6Intro": "FX_Reel6Intro/R6intro_",

                    "ExpandingFrame": "FX_FireNrg/FX_FireNrg_",
                    "ScatterFire": "FX_S_Fire/FX_S_Fire_",
                    "RowDivider": "FX_Divider/Divider_",
                    "WildExpand3": "W_Expand_3x3/W_Expand3x3_",
                    "WildExpand6": "W_Expand_6x6/W_Expand6x6_",
                    "Shatter": "FX_Win_Shatter/WinShatter_",
                    "BigWinFire": "FX_BW_Fire/BW_Fire_",
                    "WildLand": "W_Landing/W_Landing_",
                    "shockWaveExplosion": "FX_Shockwave/Shockwave_",

                    "WildFire": "FX_W_Fire/FX_W_Fire_",
                    "WildIgnite": "FX_W_Ignition/FX_Ignition_",
                    "WildIdle": "FX_W_Ignition_Idle/FX_Ignition_Idle_",
                    "WildDied": "FX_W_Ignition_Nowin/FX_Ignition_NoWin_",

                    "WildFireSpin": "FX_W_Fire_Loop/FX_W_Loop_",

                    "Spark": "FX_B_Spark_Loop/FX_B_Loop_",
                    "JumpWildDark": "Jumping_Wild/W_Jumping_Dis",
                    "JumpFire": "FX_Jumping_Fire/Jumping_Fire_",
                    "Reel6Idle": "FX_Reel_6_Idle/Reel_6_Idle_",
                    "Reel_Electric": "FX_Jumping_Electric/FX_Electric_",
                    "Attention_sector": "FX_Jumping_attention_sector/Attention_Sector_",

                    "BigWinFireLoop": "FX_W_Fire_Frame/FX_W_Frame_",

                    "ReelAttentionFire": "FX_Reel_Att_Fire/Reel_Att_Fire_",
                    "ReelAttentionBoom": "FX_Xplod/Xplod_",

                    "ReelBackground": "reel_bg",
                    "noServiceBanner": "Header/train_noservice"
                }
            },
            {
                name: "freespin",
                assets: [
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json")
                ],
                animations: {
                    "upgradeImg": "upgradeImage"
                }
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("Retrigger", "spine/Retrigger.json"),
                    new SpineAsset("JW_SPINE", "spine/Jumping_Wild_2.json"),
                    new SpineAsset("reel6Boom", "spine/Reel_6_Bending.json"),
                    new SpineAsset("Header", "spine/Header_Loop.json"),
                    new SpineAsset("Police", "spine/Police_FS.json"),
                    new SpineAsset("crack", "spine/FX_Shatter.json"),
                    new SpineAsset("Poster_Riot", "spine/Screen_Riot_v2.json"),
                    new SpineAsset("Poster_Disobey", "spine/Screen_disobeySpins.json"),
                    new SpineAsset("Poster_Chaos", "spine/Screen_chaosSpins.json"),
                    new SpineAsset("Poster_MassTransitBBQS", "spine/Screen_massTransitBBQSpins.json"),
                    new SpineAsset("Poster_Bigwin1", "spine/Big_Win1.json"),
                    new SpineAsset("Poster_Bigwin2", "spine/Big_Win2.json"),
                    new SpineAsset("Poster_Bigwin3", "spine/Big_Win3.json"),
                    new SpineAsset("Poster_Bigwin4", "spine/Big_Win4.json"),
                    new SpineAsset("Poster_Bigwin5", "spine/Big_Win5.json"),
                    new SpineAsset("No_Win", "spine/No_Win.json"),
                    new SpineAsset("superX1", "spine/Xpand_M1_7.json"),
                    new SpineAsset("superX2", "spine/Xpand_M2_7.json"),
                    new SpineAsset("superX3", "spine/Xpand_M3_7.json"),
                    new SpineAsset("superX4", "spine/Xpand_M4_7.json"),
                    new SpineAsset("superX5", "spine/Xpand_M5_7.json"),

                    new SpineAsset("fog", "spine/Idle_Fog.json"),

                    new SpineAsset("winCap", "spine/Wincap.json"),
                    new SpineAsset("gameBG", "spine/bg.json"),
                    new SpineAsset("reelFrame", "spine/reelFrame.json"),
                    new SpineAsset("BG_End", "spine/fsOutroTrain.json"),

                    new SpineAsset("expandingLightning", "spine/xWaysExpanding/expandingLightning.json"),

                    new SpineAsset("expand_L1", "spine/xWaysExpanding/expanding_L1.json"),
                    new SpineAsset("expand_L2", "spine/xWaysExpanding/expanding_L2.json"),
                    new SpineAsset("expand_L3", "spine/xWaysExpanding/expanding_L3.json"),
                    new SpineAsset("expand_L4", "spine/xWaysExpanding/expanding_L4.json"),
                    new SpineAsset("expand_L5", "spine/xWaysExpanding/expanding_L5.json"),
                    new SpineAsset("expand_M1", "spine/xWaysExpanding/expanding_M1.json"),
                    new SpineAsset("expand_M2", "spine/xWaysExpanding/expanding_M2.json"),
                    new SpineAsset("expand_M3", "spine/xWaysExpanding/expanding_M3.json"),
                    new SpineAsset("expand_M4", "spine/xWaysExpanding/expanding_M4.json"),
                    new SpineAsset("expand_M5", "spine/xWaysExpanding/expanding_M5.json"),

                    new SpineAsset("topTrainSpine", "spine/trains/trainsNew/topTrain.json"),
                    new SpineAsset("bottomTrainSpine", "spine/trains/trainsNew/bottomTrain.json"),
                    new SpineAsset("pipeBomb", "spine/pipeBomb.json"),
                    new SpineAsset("scatterSymbol", "spine/bonus.json"),
                    new SpineAsset("notInService", "spine/not_in_service.json"),
                    new SpineAsset("fsOutro", "spine/Screen_fsOutro.json"),
                    new SpineAsset("trainBlast", "spine/5_bonus_fireTrigger.json"),

                    new SpineAsset("foreground", "spine/foreground.json")
                ]
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ]
            },
            {
                name: "cropLSymbols",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("cropLSymbols0", "sheets/cropLSymbols/cropLSymbols0.json")
                ]
            }
        ]
    };

}
